const initalState = null

const circulationListReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_CIRCULATION_LIST":
			return data
		
		default:
			return state
	}
}

const circulationDetailReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_CIRCULATION_DETAIL":
			return data
		
		default:
			return state
	}
}

const userListReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_USER_LIST":
			return data
		
		default:
			return state
	}
}

const userGroupListReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_USER_GROUP_LIST":
			return data
		
		default:
			return state
	}
}


const userChosenReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "ADD_CHOSEN_USER":
			return data
		
		default:
			return state
	}
}


const circulationDataReducer = (state = initalState, action) => {
	const {type, data} = action

	switch (type) {
		case "CREATE_CIRCULATION_DATA":
			return data
		
		default:
			return state
	}
}






export {
	circulationListReducer,
	circulationDetailReducer,
	userListReducer,
	userGroupListReducer,
	userChosenReducer,
	circulationDataReducer
}